<template>
  <div class="follow-order">
    <AssetNavigation :title="buildingId ? 'آسانسورهای ' + (buildingRecord.verbose_name || 'ساختمان انتخاب‌شده') : 'همه آسانسورها'" description="جزئیات هر آسانسور، مشخصات فنی و تجهیزات نصب‌شده را از عملیات همان ردیف ببینید." :links="navigationLinks">
      <router-link v-if="buildingId" to="/elevatormanagement/elevatorlist">همه آسانسورها</router-link>
      <router-link v-if="buildingId" class="primary" :to="{name:'createElevator',params:{id:buildingId}}">+ آسانسور در این ساختمان</router-link>
    </AssetNavigation>
    <div class="box list-box">
      <div>
        <Tableview
          :recordCount="totalDataCount"
          :page="page"
          :hover="true"
          :bordered="true"
          :showNoContent="loadingList"
          :showNoData="!loadingList && dataPackage.length === 0"
          :errorMessage="listError"
          @retry="getDataPackage(20, 20 * (page - 1))"
        >
          <template #controls
            ><AssetStatusFilter v-model="assetStatus" @input="applyFilters" /><label class="ordering-title">ترتیب ثبت</label
            ><b-form-select
              aria-label="ترتیب ثبت"
              v-model="selected"
              :options="options"
              class="ordering"
              value-field="item"
              text-field="name"
              @change="applyFilters"
            ></b-form-select
          ></template>
          <template #footer
            ><pagination
              :disabled="loadingList"
              v-model="page"
              :per-page="20"
              :records="totalDataCount"
              @paginate="myCallback"
          /></template>

          <template #TableTitle>
            <tr>
              <th>ردیف</th>
              <th>نام ساختمان</th>
              <th>شهر</th>
              <th>آدرس</th>
              <th>نوع ساختمان</th>
              <th>ظرفیت آسانسور</th>
              <th>کد آسانسور</th>
              <th>تعداد طبقات</th>
              <th>نام آسانسور</th>
              <th>نوع آسانسور</th>
              <th>وضعیت</th><th>عملیات</th>
            </tr>
          </template>

          <template #TableBody>
            <tr v-for="(item, index) in dataPackage" :key="item.id">
              <td class="persian-number">
                {{ 20 * (page - 1) + 1 + index }}
              </td>
              <td>{{ item.building.verbose_name }}</td>
              <td>{{ (item.building.city && item.building.city.name) || '—' }}</td>
              <td>{{ item.building.address }}</td>
              <td>{{ item.building.type === 'Complex' ? 'مجتمع' : 'ساختمان' }}</td>
              <td>{{ item.elevator.capacity }}</td>
              <td dir="ltr">{{ item.elevator.code || '—' }}</td>
              <td>{{ item.elevator.number_of_floors }}</td>
              <td>{{ item.elevator.title }}</td>
              <td>{{ item.elevator.type }}</td>
              <td>{{ assetState(item.elevator) }}</td>
              <td>
                <AssetActions kind="elevator" :record="item.elevator" @changed="getDataPackage(20, 20 * (page - 1))" :extra="[{ label: 'جزئیات ساختمان', icon: 'building', hidden: !item.building.id, to: '/elevatormanagement/buildingdetail/' + item.building.id + (item.elevator.is_deleted ? '?deleted=true' : '') }, { label: 'جزئیات آسانسور', icon: 'elevator', to: '/elevatormanagement/elevatordetail/' + item.elevator.id + (item.elevator.is_deleted ? '?deleted=true' : '') }]" />
              </td>
            </tr>
          </template>
        </Tableview>
      </div>
    </div>
  </div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';

import AssetActions from '@/components/AssetActions.vue';
import AssetStatusFilter from '@/components/AssetStatusFilter.vue';
import assetList from '@/utils/assetList';
import AssetNavigation from '@/components/AssetNavigation.vue';
export default {
  mixins: [assetList],
  components: { AssetActions, AssetStatusFilter, AssetNavigation,
    Tableview,
    Pagination,
  },
  data() {
    return {
      loadingList: true,
      listError: '',
      dataPackage: [],
      page: 1,
      totalDataCount: 0,
      selected: '-id',
      buildingRecord: {}, requestVersion: 0,
      options: [
        { item: 'id', name: 'ترتیب ثبت' },
        { item: '-id', name: 'جدیدترین' },
        { item: 'title', name: 'عنوان' },
        { item: '-title', name: 'عنوان (نزولی)' },
      ],
    };
  },
  mounted() {
    this.getDataPackage();
    this.getBuilding();
  },
  computed: {
    buildingId() { const value=String(this.$route.query.building || ''); return /^[1-9]\d*$/.test(value) ? value : ''; },
    navigationLinks() { return [{label:'مجتمع‌ها',to:'/elevatormanagement/groupbuildinglist'}, {label:this.buildingRecord.parent ? 'ساختمان‌های این مجتمع' : 'همه ساختمان‌ها',to:{name:'buildingList',query:this.buildingRecord.parent ? {parent:this.buildingRecord.parent} : {}}}]; },
  },
  watch: { '$route.query.building'() { this.buildingRecord={}; this.applyFilters(); this.getBuilding(); } },
  methods: {
    async getBuilding() {
      if (!this.buildingId) return;
      const id=this.buildingId, project=this.projectId;
      const res=await this.$ApiServiceLayer.get(`/api/visit/BuildingEdits/${id}/?p=${project}${this.assetStatus === 'deleted' ? '&include_deleted=true' : ''}`, '');
      if (res.status===200 && id===this.buildingId && project===this.projectId) this.buildingRecord=res.data;
    },
    applyFilters() {
      this.page = 1;
      return this.getDataPackage();
    },
    removeFilter() {
      this.page = 1;
    },

    async getDataPackage(limit = 20, offset = 0, order = null) {
      const version=++this.requestVersion;
      this.loadingList = true;
      this.listError = '';
      try {
        let url =
          '/api/visit/ElevatorListCreate/' +
          '?limit=' +
          limit +
          '&offset=' +
          offset +
          '&p=' +
          this.$STORE.state.userConfig.setProjectId +
          this.statusQuery + '&ordering=' +
          this.selected;
        if (this.buildingId) url += '&building=' + this.buildingId;

        if (order) {
          url += '&ordering=' + order;
        }

        const res = await this.$ApiServiceLayer.get(url, '');
        if (version !== this.requestVersion) return;
        if (res.status !== 200) {
          this.listError = this.$ApiServiceLayer.getErrorMessage(res);
          return;
        }
        if (res.status === 200) {
          this.dataPackage = res.data.results.map(elevator => ({ id: elevator.id, elevator, building: elevator.building || {} }));
          this.totalDataCount = res.data.count;
        }
      } finally {
        if (version===this.requestVersion) this.loadingList = false;
      }
    },
    elevatorItemDetailsFunc(id) {
      this.$router.push('/elevatormanagement/elevatordetail/' + id);
    },

    async myCallback(page) {
      const offset = (page - 1) * 20;
      await this.getDataPackage(20, offset);
    },

    visitDetail(id) {
      this.$router.push('/elevatormanagement/buildingdetail/' + id);
    },
  },
};
</script>
<style scoped>
.elevator-icon {
  width: 22px;
}
</style>
